module.exports = __webpack_public_path__ + "img/1.282b4409.png";